export enum LabelPosition {
    Left = 'left',
    Right = 'right',
}
